/* eslint-disable react/prop-types */
import { Link } from "gatsby"
import React from "react"
import Logo from "../images/logo.svg"
const Reisentyp = (props) => {
  var foo
  if (props.reisentyp === "Wanderreise") {
    foo = "Wanderreisen"
  } else if (props.reisentyp === "Segel-Kreuzfahrt") {
    foo = "Segelkreuzfahrten"
  } else if (props.reisentyp === "Golfreise") {
    foo = "Golfreisen"
  }
  return (
    <Link
      to={`/${foo.toLowerCase()}`}
      className="sub-menu-nav-link"
      style={{ textDecoration: "none", color: "black" }}
    >
      <span className="nav-reisentyp">{foo} →&nbsp;</span>
    </Link>
  )
}

const SubMenu = (props) => (
  <nav className={`sub-menu ${props.reisentyp.toLowerCase()}`}>
    <div className="sub-menu-container">
      <div className="nav-hierarchy">
        <Link style={{ height: "26px" }} to="/">
          <img src={Logo}></img>
        </Link>
        <div style={{ display: "flex" }}>
          <Reisentyp reisentyp={props.reisentyp} />
          <span className="nav-destination">{props.destination}</span>
        </div>
      </div>
      {props.showBuchenButton && (
        <div
          className={
            "nav-buchen-button " +
            "nav-buchen-button-" +
            props.reisentyp.toLowerCase()
          }
        >
          <button type="button" onClick={props.openModal}>
            Buchungsanfrage
          </button>
        </div>
      )}
    </div>
  </nav>
)

export default SubMenu
